import { useEffect, useState } from 'react';
import { useRefById } from './useRefById';

export const DEFAULT_INTERSECTION_OBSERVER_ENTRY = {
  isIntersecting: true,
  intersectionRatio: 1,
} as IntersectionObserverEntry;

interface UseObserveElementVisibilityProps {
  readonly ref?: React.RefObject<HTMLElement | undefined>;
  readonly id?: string;
  readonly threshold?: number;
  readonly enabled?: boolean;
}

export const useObserveElementVisibility = ({
  ref,
  id,
  threshold,
  enabled = true,
}: UseObserveElementVisibilityProps): IntersectionObserverEntry | undefined => {
  const [entry, setEntry] = useState<IntersectionObserverEntry>();
  const { ref: refById, isElementFound } = useRefById(id);

  useEffect(() => {
    const element = ref?.current ?? refById.current;
    if (!element || !enabled) return;

    const observer = new IntersectionObserver(
      entries => {
        setEntry(entries[0]);
      },
      { threshold },
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [isElementFound, ref, refById, threshold, enabled]);

  if (id == null && ref == null) return;

  return entry ?? DEFAULT_INTERSECTION_OBSERVER_ENTRY;
};
